var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col"},[_c('multiple-file-input',{attrs:{"id":"file","fields":{ category_id: _vm.category.id, process_id: _vm.category.process_id },"items":_vm.collection,"url":_vm.uploadUrl},on:{"error":function($event){_vm.$toasted.error(arguments[1])},"success":_vm.handleUploadFile,"remove-file":_vm.handleRemoveFile}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab82376","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/bl/ProcessItems.vue
// module id = 981
// module chunks = 1